import { httpResource } from '@angular/common/http';
import { inject, Injectable, Signal } from '@angular/core';
import { ENVIRONMENT_SERVICE_TOKEN } from '@mwe/constants';
import { InternetDocuments } from '@mwe/models';
import { EnvironmentService } from '../../environment/environment.service';

@Injectable({
  providedIn: 'root',
})
export class InternetDocumentUrlService {
  private readonly environmentService = inject<EnvironmentService>(ENVIRONMENT_SERVICE_TOKEN);
  private readonly resourceUrl: string;

  constructor() {
    this.resourceUrl = this.environmentService.getApiUrl() + 'api/public/internet-document-url';
  }

  getInternetDocumentUrls(internetTariff: Signal<string>, tvOption: Signal<string>, isMVNO: Signal<boolean>) {
    return httpResource<InternetDocuments>(
      () => {
        const tariff = internetTariff();
        if (!tariff) {
          return undefined;
        }

        return {
          url: this.resourceUrl,
          params: {
            internetTariff: tariff,
            tvOption: tvOption(),
            isMVNO: isMVNO(),
          },
        };
      },
      {
        defaultValue: {
          contractSummaryUrl: '',
          agbUrl: '',
          ebLbUrl: '',
          ebLbTvUrl: '',
          ruecktrittsbelehrungUrl: '',
        },
      },
    );
  }
}
